module.exports = __webpack_public_path__ + "img/ararat-age-confirm-logo.f122b4cc.png";